/**
 * Generated by orval 🍺
 * Do not edit manually.
 * DevSMS API v2
 * The dashboard's API (LLD §26.2), and the source Orval generates the
 * dashboard's client from (`dashboard/orval.config.ts`).
 *
 * This document describes the Go server as built. It is held to the code
 * by `test/contract`: the routes it lists are exactly the routes served,
 * in normal and in standalone mode (`TestV2Routes_MatchTheSpecInBothModes`),
 * and every answer the integration, contract and end-to-end tests provoke
 * is validated against the operation it documents
 * (`test/harness/apispec.Validating`). Spectral lints it with
 * `api/.spectral.yaml` (`make spec`).
 *
 * Conventions:
 *   - JSON is camelCase; enums are snake_case; times are RFC 3339 UTC.
 *   - Money is a whole number of XAF (ISO 4217 exponent 0) in a plain
 *     integer field, with a sibling `currency` field (always `XAF`) on
 *     the objects that carry one. There is no `{amount, currency}`
 *     wrapper object (DV-145).
 *   - Lists that can grow are keyset-paged: `?cursor=&limit=` in,
 *     `{items, nextCursor, hasMore}` out. A cursor is opaque and signed;
 *     a tampered one answers 422 `invalid_cursor`. Short, bounded lists
 *     answer `{items}`.
 *   - Errors are RFC 9457 `application/problem+json`. The machine code is
 *     the last segment of `type`, in kebab case
 *     (`…/problems/wallet-insufficient` is the code `wallet_insufficient`);
 *     `x-problem-codes` lists every code with its status. There is no
 *     separate `code` member (DV-145).
 *   - Authentication is a bearer access token from `POST /auth/login`
 *     (or Google, TOTP, refresh, invite). API keys are not accepted on
 *     v2; they are the v1 credential.
 *   - `x-permission` names the permission an operation requires (every
 *     one listed, when it is a list). Account routes (`/account/*`) also
 *     admit any staff user without it (DV-55). Every `/admin/*` route
 *     also refuses a staff user who has not enrolled TOTP (403
 *     `totp_enrolment_required`).
 *   - `x-step-up: true` marks an operation that needs an `X-Step-Up`
 *     token from `POST /auth/step-up`, under 5 minutes old (403
 *     `step_up_required` otherwise).
 *   - `x-idempotency: required` marks an operation that needs an
 *     `Idempotency-Key` header (422 `idempotency_key_required`); a
 *     repeat replays the first answer byte for byte with
 *     `Idempotent-Replay: true`. `x-idempotency: exempt` marks a write
 *     in a money area that deliberately takes none, and
 *     `x-idempotency-reason` says why.
 *   - `x-standalone: absent` marks an operation that is not mounted when
 *     `STANDALONE_MODE=true` (it answers 404 there).
 *   - `?lang=fr|en` (or `Accept-Language`) chooses the language of every
 *     problem's `detail` and of the PDFs; French is the default.
 *   - CORS admits one origin, the deployment's `DASHBOARD_URL`, with
 *     credentials (none when it is unset; never `*`). Preflights are
 *     answered `204` before authentication and rate limiting. Allowed
 *     request headers: `Authorization`, `Content-Type`,
 *     `Accept-Language`, `Idempotency-Key`, `X-Step-Up`, `X-Sdk-Client`;
 *     exposed: `Idempotent-Replay`, `RateLimit-Limit`,
 *     `RateLimit-Remaining`, `RateLimit-Reset`, `Retry-After`,
 *     `X-Request-Id`, `Content-Disposition`. (`/api/v1` keeps Nest's
 *     `enableCors()`: `Access-Control-Allow-Origin: *`, no credentials.)
 *
 * OpenAPI spec version: 2.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminListPlans200,
  AdminPlan,
  AdminSetUserLimitsBody,
  AdminSetUserSubscriptionBody,
  ConflictResponse,
  CurrentSubscription,
  ForbiddenResponse,
  InternalErrorResponse,
  ListPlans200,
  NotFoundResponse,
  PayloadTooLargeResponse,
  PaymentRequiredResponse,
  PlanFields,
  Purchase,
  PurchasePlanBody,
  Quote,
  QuotePlanBody,
  TooManyRequestsResponse,
  UnauthorizedResponse,
  UnavailableResponse,
  UnprocessableResponse,
  UpdateSubscriptionBody
} from '../model';

import { apiFetch } from '../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getListPlansUrl = () => {




  return `/plans`
}

/**
 * A plan not for sale, and every plan in standalone mode, has no price.
 * @summary The public plan catalogue with prices
 */
export const listPlans = async ( options?: Parameters<typeof apiFetch>[1]): Promise<ListPlans200> => {

  return apiFetch<ListPlans200>(getListPlansUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPlansQueryKey = () => {
    return [
    `/plans`
    ] as const;
    }


export const getListPlansQueryOptions = <TData = Awaited<ReturnType<typeof listPlans>>, TError = InternalErrorResponse | UnavailableResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlans>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPlansQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPlans>>> = ({ signal }) => listPlans({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPlans>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPlansQueryResult = NonNullable<Awaited<ReturnType<typeof listPlans>>>
export type ListPlansQueryError = InternalErrorResponse | UnavailableResponse


export function useListPlans<TData = Awaited<ReturnType<typeof listPlans>>, TError = InternalErrorResponse | UnavailableResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlans>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPlans>>,
          TError,
          Awaited<ReturnType<typeof listPlans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPlans<TData = Awaited<ReturnType<typeof listPlans>>, TError = InternalErrorResponse | UnavailableResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlans>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPlans>>,
          TError,
          Awaited<ReturnType<typeof listPlans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPlans<TData = Awaited<ReturnType<typeof listPlans>>, TError = InternalErrorResponse | UnavailableResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlans>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The public plan catalogue with prices
 */

export function useListPlans<TData = Awaited<ReturnType<typeof listPlans>>, TError = InternalErrorResponse | UnavailableResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlans>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPlansQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getQuotePlanUrl = (planId: string,) => {




  return `/plans/${planId}/quote`
}

/**
 * The quote is stored and can be bought until `expiresAt`.
 * @summary Quote buying a plan from the wallet
 */
export const quotePlan = async (planId: string,
    quotePlanBody: QuotePlanBody, options?: Parameters<typeof apiFetch>[1]): Promise<Quote> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<Quote>(getQuotePlanUrl(planId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(quotePlanBody)
  }
);}





export const getQuotePlanMutationKey = () => ['quotePlan'] as const;

export const getQuotePlanMutationOptions = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | PayloadTooLargeResponse | UnprocessableResponse | TooManyRequestsResponse | InternalErrorResponse | UnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof quotePlan>>, TError,QuotePlanMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof quotePlan>>, TError,QuotePlanMutationVariables, TContext> => {

const mutationKey = getQuotePlanMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof quotePlan>>, QuotePlanMutationVariables> = (props) => {
          const {planId,data} = props ?? {};

          return  quotePlan(planId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type QuotePlanMutationResult = NonNullable<Awaited<ReturnType<typeof quotePlan>>>
    export type QuotePlanMutationBody = QuotePlanBody
    export type QuotePlanMutationError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | PayloadTooLargeResponse | UnprocessableResponse | TooManyRequestsResponse | InternalErrorResponse | UnavailableResponse
    export type QuotePlanMutationVariables = {planId: string;data: QuotePlanBody}

    /**
 * @summary Quote buying a plan from the wallet
 */
export const useQuotePlan = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | PayloadTooLargeResponse | UnprocessableResponse | TooManyRequestsResponse | InternalErrorResponse | UnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof quotePlan>>, TError,QuotePlanMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof quotePlan>>,
        TError,
        QuotePlanMutationVariables,
        TContext
      > => {
      return useMutation(getQuotePlanMutationOptions(options), queryClient);
    }
    export const getPurchasePlanUrl = (planId: string,) => {




  return `/plans/${planId}/purchase`
}

/**
 * Debits the wallet and writes the subscription in one transaction. A
 * downgrade is scheduled for the period end and debits nothing.
 * @summary Buy a quoted plan from the wallet
 */
export const purchasePlan = async (planId: string,
    purchasePlanBody: PurchasePlanBody, options?: Parameters<typeof apiFetch>[1]): Promise<Purchase> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<Purchase>(getPurchasePlanUrl(planId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(purchasePlanBody)
  }
);}





export const getPurchasePlanMutationKey = () => ['purchasePlan'] as const;

export const getPurchasePlanMutationOptions = <TError = UnauthorizedResponse | PaymentRequiredResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | PayloadTooLargeResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purchasePlan>>, TError,PurchasePlanMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof purchasePlan>>, TError,PurchasePlanMutationVariables, TContext> => {

const mutationKey = getPurchasePlanMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof purchasePlan>>, PurchasePlanMutationVariables> = (props) => {
          const {planId,data} = props ?? {};

          return  purchasePlan(planId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PurchasePlanMutationResult = NonNullable<Awaited<ReturnType<typeof purchasePlan>>>
    export type PurchasePlanMutationBody = PurchasePlanBody
    export type PurchasePlanMutationError = UnauthorizedResponse | PaymentRequiredResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | PayloadTooLargeResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse
    export type PurchasePlanMutationVariables = {planId: string;data: PurchasePlanBody}

    /**
 * @summary Buy a quoted plan from the wallet
 */
export const usePurchasePlan = <TError = UnauthorizedResponse | PaymentRequiredResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | PayloadTooLargeResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purchasePlan>>, TError,PurchasePlanMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof purchasePlan>>,
        TError,
        PurchasePlanMutationVariables,
        TContext
      > => {
      return useMutation(getPurchasePlanMutationOptions(options), queryClient);
    }
    export const getGetSubscriptionUrl = () => {




  return `/billing/subscription`
}

/**
 * @summary The plan in force, the subscription and the usage
 */
export const getSubscription = async ( options?: Parameters<typeof apiFetch>[1]): Promise<CurrentSubscription> => {

  return apiFetch<CurrentSubscription>(getGetSubscriptionUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSubscriptionQueryKey = () => {
    return [
    `/billing/subscription`
    ] as const;
    }


export const getGetSubscriptionQueryOptions = <TData = Awaited<ReturnType<typeof getSubscription>>, TError = UnauthorizedResponse | ForbiddenResponse | InternalErrorResponse | UnavailableResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscription>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubscriptionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscription>>> = ({ signal }) => getSubscription({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSubscription>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSubscriptionQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscription>>>
export type GetSubscriptionQueryError = UnauthorizedResponse | ForbiddenResponse | InternalErrorResponse | UnavailableResponse


export function useGetSubscription<TData = Awaited<ReturnType<typeof getSubscription>>, TError = UnauthorizedResponse | ForbiddenResponse | InternalErrorResponse | UnavailableResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscription>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubscription>>,
          TError,
          Awaited<ReturnType<typeof getSubscription>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSubscription<TData = Awaited<ReturnType<typeof getSubscription>>, TError = UnauthorizedResponse | ForbiddenResponse | InternalErrorResponse | UnavailableResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscription>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubscription>>,
          TError,
          Awaited<ReturnType<typeof getSubscription>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSubscription<TData = Awaited<ReturnType<typeof getSubscription>>, TError = UnauthorizedResponse | ForbiddenResponse | InternalErrorResponse | UnavailableResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscription>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The plan in force, the subscription and the usage
 */

export function useGetSubscription<TData = Awaited<ReturnType<typeof getSubscription>>, TError = UnauthorizedResponse | ForbiddenResponse | InternalErrorResponse | UnavailableResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscription>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSubscriptionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUpdateSubscriptionUrl = () => {




  return `/billing/subscription`
}

/**
 * A body asking for neither is refused with 422 `nothing_to_change`.
 * @summary Switch auto-renew or drop a scheduled downgrade
 */
export const updateSubscription = async (updateSubscriptionBody: UpdateSubscriptionBody, options?: Parameters<typeof apiFetch>[1]): Promise<CurrentSubscription> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<CurrentSubscription>(getUpdateSubscriptionUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateSubscriptionBody)
  }
);}





export const getUpdateSubscriptionMutationKey = () => ['updateSubscription'] as const;

export const getUpdateSubscriptionMutationOptions = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | PayloadTooLargeResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSubscription>>, TError,UpdateSubscriptionMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSubscription>>, TError,UpdateSubscriptionMutationVariables, TContext> => {

const mutationKey = getUpdateSubscriptionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSubscription>>, UpdateSubscriptionMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateSubscription(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof updateSubscription>>>
    export type UpdateSubscriptionMutationBody = UpdateSubscriptionBody
    export type UpdateSubscriptionMutationError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | PayloadTooLargeResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse
    export type UpdateSubscriptionMutationVariables = {data: UpdateSubscriptionBody}

    /**
 * @summary Switch auto-renew or drop a scheduled downgrade
 */
export const useUpdateSubscription = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | PayloadTooLargeResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSubscription>>, TError,UpdateSubscriptionMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateSubscription>>,
        TError,
        UpdateSubscriptionMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateSubscriptionMutationOptions(options), queryClient);
    }
    export const getAdminSetUserLimitsUrl = (id: string,) => {




  return `/admin/users/${id}/limits`
}

/**
 * A limit left out or null is the plan's; -1 is unlimited.
 * @summary Replace an account's custom limits
 */
export const adminSetUserLimits = async (id: string,
    adminSetUserLimitsBody: AdminSetUserLimitsBody, options?: Parameters<typeof apiFetch>[1]): Promise<CurrentSubscription> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<CurrentSubscription>(getAdminSetUserLimitsUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminSetUserLimitsBody)
  }
);}





export const getAdminSetUserLimitsMutationKey = () => ['adminSetUserLimits'] as const;

export const getAdminSetUserLimitsMutationOptions = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | PayloadTooLargeResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSetUserLimits>>, TError,AdminSetUserLimitsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminSetUserLimits>>, TError,AdminSetUserLimitsMutationVariables, TContext> => {

const mutationKey = getAdminSetUserLimitsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminSetUserLimits>>, AdminSetUserLimitsMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  adminSetUserLimits(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminSetUserLimitsMutationResult = NonNullable<Awaited<ReturnType<typeof adminSetUserLimits>>>
    export type AdminSetUserLimitsMutationBody = AdminSetUserLimitsBody
    export type AdminSetUserLimitsMutationError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | PayloadTooLargeResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse
    export type AdminSetUserLimitsMutationVariables = {id: string;data: AdminSetUserLimitsBody}

    /**
 * @summary Replace an account's custom limits
 */
export const useAdminSetUserLimits = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | PayloadTooLargeResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSetUserLimits>>, TError,AdminSetUserLimitsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminSetUserLimits>>,
        TError,
        AdminSetUserLimitsMutationVariables,
        TContext
      > => {
      return useMutation(getAdminSetUserLimitsMutationOptions(options), queryClient);
    }
    export const getAdminGetUserSubscriptionUrl = (id: string,) => {




  return `/admin/users/${id}/subscription`
}

/**
 * What `adminSetUserSubscription` and `adminSetUserLimits` answer after a
 * change, read before one. An unknown account is 404 `user_not_found`.
 * @summary An account's plan, subscription and usage
 */
export const adminGetUserSubscription = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<CurrentSubscription> => {

  return apiFetch<CurrentSubscription>(getAdminGetUserSubscriptionUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminGetUserSubscriptionQueryKey = (id: string,) => {
    return [
    `/admin/users/${id}/subscription`
    ] as const;
    }


export const getAdminGetUserSubscriptionQueryOptions = <TData = Awaited<ReturnType<typeof adminGetUserSubscription>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse | UnavailableResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetUserSubscription>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminGetUserSubscriptionQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetUserSubscription>>> = ({ signal }) => adminGetUserSubscription(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGetUserSubscription>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminGetUserSubscriptionQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetUserSubscription>>>
export type AdminGetUserSubscriptionQueryError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse | UnavailableResponse


export function useAdminGetUserSubscription<TData = Awaited<ReturnType<typeof adminGetUserSubscription>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse | UnavailableResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetUserSubscription>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetUserSubscription>>,
          TError,
          Awaited<ReturnType<typeof adminGetUserSubscription>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGetUserSubscription<TData = Awaited<ReturnType<typeof adminGetUserSubscription>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse | UnavailableResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetUserSubscription>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetUserSubscription>>,
          TError,
          Awaited<ReturnType<typeof adminGetUserSubscription>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGetUserSubscription<TData = Awaited<ReturnType<typeof adminGetUserSubscription>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse | UnavailableResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetUserSubscription>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary An account's plan, subscription and usage
 */

export function useAdminGetUserSubscription<TData = Awaited<ReturnType<typeof adminGetUserSubscription>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse | UnavailableResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetUserSubscription>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminGetUserSubscriptionQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminSetUserSubscriptionUrl = (id: string,) => {




  return `/admin/users/${id}/subscription`
}

/**
 * The new period runs from now for the interval. It never charges the
 * wallet and never renews (`autoRenew` is read and ignored). An active
 * wallet-paid period is replaced only with `override` (409
 * `subscription_active_wallet`).
 * @summary Give an account a plan by hand
 */
export const adminSetUserSubscription = async (id: string,
    adminSetUserSubscriptionBody: AdminSetUserSubscriptionBody, options?: Parameters<typeof apiFetch>[1]): Promise<CurrentSubscription> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<CurrentSubscription>(getAdminSetUserSubscriptionUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminSetUserSubscriptionBody)
  }
);}





export const getAdminSetUserSubscriptionMutationKey = () => ['adminSetUserSubscription'] as const;

export const getAdminSetUserSubscriptionMutationOptions = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | PayloadTooLargeResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSetUserSubscription>>, TError,AdminSetUserSubscriptionMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminSetUserSubscription>>, TError,AdminSetUserSubscriptionMutationVariables, TContext> => {

const mutationKey = getAdminSetUserSubscriptionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminSetUserSubscription>>, AdminSetUserSubscriptionMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  adminSetUserSubscription(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminSetUserSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof adminSetUserSubscription>>>
    export type AdminSetUserSubscriptionMutationBody = AdminSetUserSubscriptionBody
    export type AdminSetUserSubscriptionMutationError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | PayloadTooLargeResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse
    export type AdminSetUserSubscriptionMutationVariables = {id: string;data: AdminSetUserSubscriptionBody}

    /**
 * @summary Give an account a plan by hand
 */
export const useAdminSetUserSubscription = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | PayloadTooLargeResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSetUserSubscription>>, TError,AdminSetUserSubscriptionMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminSetUserSubscription>>,
        TError,
        AdminSetUserSubscriptionMutationVariables,
        TContext
      > => {
      return useMutation(getAdminSetUserSubscriptionMutationOptions(options), queryClient);
    }
    export const getAdminListPlansUrl = () => {




  return `/admin/plans`
}

/**
 * @summary Every plan, by name
 */
export const adminListPlans = async ( options?: Parameters<typeof apiFetch>[1]): Promise<AdminListPlans200> => {

  return apiFetch<AdminListPlans200>(getAdminListPlansUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListPlansQueryKey = () => {
    return [
    `/admin/plans`
    ] as const;
    }


export const getAdminListPlansQueryOptions = <TData = Awaited<ReturnType<typeof adminListPlans>>, TError = UnauthorizedResponse | ForbiddenResponse | InternalErrorResponse | UnavailableResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListPlans>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminListPlansQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListPlans>>> = ({ signal }) => adminListPlans({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListPlans>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminListPlansQueryResult = NonNullable<Awaited<ReturnType<typeof adminListPlans>>>
export type AdminListPlansQueryError = UnauthorizedResponse | ForbiddenResponse | InternalErrorResponse | UnavailableResponse


export function useAdminListPlans<TData = Awaited<ReturnType<typeof adminListPlans>>, TError = UnauthorizedResponse | ForbiddenResponse | InternalErrorResponse | UnavailableResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListPlans>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListPlans>>,
          TError,
          Awaited<ReturnType<typeof adminListPlans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListPlans<TData = Awaited<ReturnType<typeof adminListPlans>>, TError = UnauthorizedResponse | ForbiddenResponse | InternalErrorResponse | UnavailableResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListPlans>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListPlans>>,
          TError,
          Awaited<ReturnType<typeof adminListPlans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListPlans<TData = Awaited<ReturnType<typeof adminListPlans>>, TError = UnauthorizedResponse | ForbiddenResponse | InternalErrorResponse | UnavailableResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListPlans>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Every plan, by name
 */

export function useAdminListPlans<TData = Awaited<ReturnType<typeof adminListPlans>>, TError = UnauthorizedResponse | ForbiddenResponse | InternalErrorResponse | UnavailableResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListPlans>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminListPlansQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminCreatePlanUrl = () => {




  return `/admin/plans`
}

/**
 * @summary Create a plan
 */
export const adminCreatePlan = async (planFieldsUnknownRequiredPickPlanFieldsUnknownNameDailyLimitMonthlyLimitBulkSendLimit: PlanFields & unknown & Required<Pick<PlanFields & unknown, 'name' | 'dailyLimit' | 'monthlyLimit' | 'bulkSendLimit'>>, options?: Parameters<typeof apiFetch>[1]): Promise<AdminPlan> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<AdminPlan>(getAdminCreatePlanUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(planFieldsUnknownRequiredPickPlanFieldsUnknownNameDailyLimitMonthlyLimitBulkSendLimit)
  }
);}





export const getAdminCreatePlanMutationKey = () => ['adminCreatePlan'] as const;

export const getAdminCreatePlanMutationOptions = <TError = UnauthorizedResponse | ForbiddenResponse | ConflictResponse | PayloadTooLargeResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCreatePlan>>, TError,AdminCreatePlanMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCreatePlan>>, TError,AdminCreatePlanMutationVariables, TContext> => {

const mutationKey = getAdminCreatePlanMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCreatePlan>>, AdminCreatePlanMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminCreatePlan(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCreatePlanMutationResult = NonNullable<Awaited<ReturnType<typeof adminCreatePlan>>>
    export type AdminCreatePlanMutationBody = PlanFields & unknown & Required<Pick<PlanFields & unknown, 'name' | 'dailyLimit' | 'monthlyLimit' | 'bulkSendLimit'>>
    export type AdminCreatePlanMutationError = UnauthorizedResponse | ForbiddenResponse | ConflictResponse | PayloadTooLargeResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse
    export type AdminCreatePlanMutationVariables = {data: PlanFields & unknown & Required<Pick<PlanFields & unknown, 'name' | 'dailyLimit' | 'monthlyLimit' | 'bulkSendLimit'>>}

    /**
 * @summary Create a plan
 */
export const useAdminCreatePlan = <TError = UnauthorizedResponse | ForbiddenResponse | ConflictResponse | PayloadTooLargeResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCreatePlan>>, TError,AdminCreatePlanMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCreatePlan>>,
        TError,
        AdminCreatePlanMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCreatePlanMutationOptions(options), queryClient);
    }
    export const getAdminUpdatePlanUrl = (planId: string,) => {




  return `/admin/plans/${planId}`
}

/**
 * A priced plan's name is locked (409 `plan_name_locked`).
 * @summary Change a plan
 */
export const adminUpdatePlan = async (planId: string,
    planFields: PlanFields, options?: Parameters<typeof apiFetch>[1]): Promise<AdminPlan> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<AdminPlan>(getAdminUpdatePlanUrl(planId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(planFields)
  }
);}





export const getAdminUpdatePlanMutationKey = () => ['adminUpdatePlan'] as const;

export const getAdminUpdatePlanMutationOptions = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | PayloadTooLargeResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdatePlan>>, TError,AdminUpdatePlanMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminUpdatePlan>>, TError,AdminUpdatePlanMutationVariables, TContext> => {

const mutationKey = getAdminUpdatePlanMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUpdatePlan>>, AdminUpdatePlanMutationVariables> = (props) => {
          const {planId,data} = props ?? {};

          return  adminUpdatePlan(planId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminUpdatePlanMutationResult = NonNullable<Awaited<ReturnType<typeof adminUpdatePlan>>>
    export type AdminUpdatePlanMutationBody = PlanFields
    export type AdminUpdatePlanMutationError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | PayloadTooLargeResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse
    export type AdminUpdatePlanMutationVariables = {planId: string;data: PlanFields}

    /**
 * @summary Change a plan
 */
export const useAdminUpdatePlan = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | PayloadTooLargeResponse | UnprocessableResponse | InternalErrorResponse | UnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdatePlan>>, TError,AdminUpdatePlanMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminUpdatePlan>>,
        TError,
        AdminUpdatePlanMutationVariables,
        TContext
      > => {
      return useMutation(getAdminUpdatePlanMutationOptions(options), queryClient);
    }
